import React, { FC, useEffect } from 'react';
import { Layout } from 'tea-component';
import CreditabilityTable from './components/CreditabilityTable';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { useIntl } from 'umi';



import './index.scss';

const { Content } = Layout;

const MetricsCreditability: FC = () => {
  const { formatMessage } = useIntl();
  
  useEffect(()=> {
    const pageMsg = dbiPageLogMes?.metricsCreditability;
      if (pageMsg) {
        buriedPointPage(pageMsg);
      }
  }, [])

  return (
    <Content className="dbi-source-metrics-overview">
      <Content.Header
        title={formatMessage({ id: 'dbi_metrics_creditability_title' })}
      />
      <Content.Body full>
        <CreditabilityTable />
      </Content.Body>
    </Content>
  );
};

MetricsCreditability.displayName = 'MetricsCreditability';

export default MetricsCreditability;
